export default __webpack_public_path__ + "static/media/CheckIcon.b78ebbc9.svg";